(function ($) {
    "use strict";

    $(function () {
        $.formatNumber = function formatNumber(num, isFloat) {
            let formattedNumber;
            if (!isFloat) {
                formattedNumber = Math.round(num);
            } else {
                // Removes trailing zeros and a trailing comma if it's a float
                formattedNumber = parseFloat(num.toFixed(2));
            }
            // Format number with space as thousand separator
            return new Intl.NumberFormat('hu-HU').format(formattedNumber);
        }

        $.animateCounter = function animateCounter(counter, targetValue, duration) {
            let startTime = null;
            const isFloat = Math.floor(targetValue) !== targetValue;

            function step(timestamp) {
                if (!startTime) startTime = timestamp;
                const progress = timestamp - startTime;
                const now = Math.min(progress / duration, 1) * targetValue;

                counter.textContent = $.formatNumber(now, isFloat);

                if (progress < duration) {
                    requestAnimationFrame(step);
                }
            }

            requestAnimationFrame(step);
        }

        // Keep a CSS variable in sync with the section's height.
        const sections = document.querySelectorAll(".js-section-counters-new");
        const setSectionHeightVar = (el) => {
            if (!el) return;

            // Use layout height (includes padding/borders) so CSS can rely on the actual rendered size.
            const height = Math.round(el.getBoundingClientRect().height);
            el.style.setProperty("--section-counters-new-height", `${height}px`);
        };

        if ("ResizeObserver" in window) {
            const ro = new ResizeObserver((entries) => {
                $.each(entries, (i, entry) => {
                    setSectionHeightVar(entry.target);
                });
            });

            $.each(sections, (i, section) => {
                setSectionHeightVar(section);
                ro.observe(section);
            });
        } else {
            // Fallback: set on load + window resize (older browsers).
            $.each(sections, (i, section) => setSectionHeightVar(section));
            $(window).on("resize", () => {
                $.each(sections, (i, section) => setSectionHeightVar(section));
            });
        }

        if ($('.js-template-marina-city').length == 0) {
            const counters = document.querySelectorAll(".js-counters");
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {
                        entry.target.querySelectorAll(".js-counter").forEach((counter) => {
                            const targetValue = parseFloat(counter.querySelector(".js-counter__number").textContent.replace(/\s/g, '').replace(',', '.'));
                            $.animateCounter(counter.querySelector(".js-counter__number"), targetValue, 5000);
                        });

                        observer.unobserve(entry.target);
                    }
                });
            });

            counters.forEach((counter) => {
                observer.observe(counter);
            });

        }

    });
})(jQuery);




